import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
// This isn't explicitly used, but is necessary to display the "guessed" time zone of the user.
import "moment-timezone";
import LoadingIndicator from "../shared/div";
import A11yHelpers from "../../util/A11yHelpers";
import { meetingConfirmPath, meetingTypePath, } from "../../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
class MeetingScheduler extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        this.renderTimeSlot = this.renderTimeSlot.bind(this);
        this.selectTimeSlot = this.selectTimeSlot.bind(this);
        this.onPreviousDateClick = this.onPreviousDateClick.bind(this);
        this.onNextDateClick = this.onNextDateClick.bind(this);
        this.updateAvailabilityDate = this.updateAvailabilityDate.bind(this);
        this.renderCourseSectionSchedule =
            this.renderCourseSectionSchedule.bind(this);
        this.renderScheduleElement = this.renderScheduleElement.bind(this);
        this.isOutsideRange = this.isOutsideRange.bind(this);
        // @ts-expect-error - TS2339 - Property 'virtualizedApp' does not exist on type 'MeetingScheduler'.
        this.virtualizedApp = props.virtualizedApp;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.state = {
            availabilityDate: today,
            longFocused: false,
            shortFocused: false,
        };
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (this.props.availabilityDate) {
            this.setState({ availabilityDate: this.props.availabilityDate });
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'timeSlot' implicitly has an 'any' type.
    selectTimeSlot(timeSlot) {
        this.props.onTimeSlotSelected(timeSlot);
    }
    // @ts-expect-error - TS7006 - Parameter 'timeSlot' implicitly has an 'any' type.
    isSelectedTimeSlot(timeSlot) {
        /*
         * This will make sure that the timeslot that is selected is shown as SELECTED
         * */
        let isSelected = false;
        if (this.props.selectedTimeSlot &&
            this.props.selectedTimeSlot.startTime === timeSlot.startTime &&
            this.props.selectedTimeSlot.endTime === timeSlot.endTime) {
            isSelected = true;
        }
        return isSelected;
    }
    // @ts-expect-error - TS7006 - Parameter 'timeSlot' implicitly has an 'any' type.
    renderTimeSlot(timeSlot) {
        return (_jsxs("div", Object.assign({ role: "button", className: `btn d-block p-3 mb-2 ${this.isSelectedTimeSlot(timeSlot) ? "btn-success" : "btn-outline-dark"}` }, A11yHelpers.onClickOrEnterOrSpace(() => this.selectTimeSlot(timeSlot)), { tabIndex: 0, children: [this.isSelectedTimeSlot(timeSlot) ? (_jsx("span", { className: "fa fa-check mr-1", "aria-hidden": "true" })) : (""), moment(timeSlot.startTime).format("LT"), " -", " ", moment(timeSlot.endTime).format("LT")] }), timeSlot.startTime));
    }
    // @ts-expect-error - TS7006 - Parameter 'courseSectionSchedule' implicitly has an 'any' type.
    renderCourseSectionSchedule(courseSectionSchedule) {
        return (_jsxs("div", { className: "mb-3", children: [_jsx("div", { className: "font-weight-bold", children: courseSectionSchedule.code }), courseSectionSchedule.courseSectionScheduleElements &&
                    courseSectionSchedule.courseSectionScheduleElements.map(
                    // @ts-expect-error - TS7006 - Parameter 'meetingTime' implicitly has an 'any' type.
                    (meetingTime) => (_jsx("div", { children: this.renderScheduleElement(meetingTime) }, meetingTime.id)))] }, courseSectionSchedule.id));
    }
    // @ts-expect-error - TS7006 - Parameter 'scheduleElement' implicitly has an 'any' type.
    renderScheduleElement(scheduleElement) {
        const dayProps = {
            monday: "M",
            tuesday: "T",
            wednesday: "W",
            thursday: "Th",
            friday: "F",
            saturday: "Sa",
            sunday: "Su",
        };
        // For each of the days, see if the schedule says there's a meeting on the day, and if so,
        // find the display for that day and add that to the collection of days.
        // @ts-expect-error - TS7034 - Variable 'days' implicitly has type 'any[]' in some locations where its type cannot be determined.
        const days = [];
        Reflect.ownKeys(dayProps).forEach((key) => {
            if (scheduleElement[key]) {
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string | symbol' can't be used to index type '{ readonly monday: "M"; readonly tuesday: "T"; readonly wednesday: "W"; readonly thursday: "Th"; readonly friday: "F"; readonly saturday: "Sa"; readonly sunday: "Su"; }'.
                days.push(dayProps[key]);
            }
        });
        // Join all the days of the week together and add them to the string builder.
        // @ts-expect-error - TS7005 - Variable 'days' implicitly has an 'any[]' type.
        const daysString = days.join(", ");
        // Serves as our string builder.
        const sb = [];
        if (daysString) {
            sb.push(daysString);
        }
        // Time information.
        const startTimeFormatted = this.toHumanReadableTime(scheduleElement.startTimeHours24, scheduleElement.startTimeMinutes24);
        const endTimeFormatted = this.toHumanReadableTime(scheduleElement.endTimeHours24, scheduleElement.endTimeMinutes24);
        sb.push(`${startTimeFormatted} - ${endTimeFormatted}`);
        return sb.join(" ");
    }
    /**
     * Converts a 24-hour based time into a more human-friendly format.
     *
     * @param {number} hours24 - The hours (based on 24-hour time) component of the time.
     * @param {number} minutes - The minutes component of the time.
     * @returns {string} A more human friendly time, like 8:24p or 12:05a
     */
    // @ts-expect-error - TS7006 - Parameter 'hours24' implicitly has an 'any' type. | TS7006 - Parameter 'minutes' implicitly has an 'any' type.
    toHumanReadableTime(hours24, minutes) {
        // Convert 24 hour time to 12 hour time format.
        let hours = hours24;
        let ampm = "am";
        if (hours24 > 12) {
            hours -= 12;
            ampm = "pm";
        }
        else if (hours24 === 12) {
            ampm = "pm";
        }
        else if (hours24 === 0) {
            hours = 12;
        }
        let minutesStr = minutes.toString();
        if (minutes < 10) {
            minutesStr = `0${minutes}`;
        }
        return `${hours}:${minutesStr} ${ampm}`;
    }
    renderBackButton() {
        const isAvailabilityDateToday = moment(this.props.availabilityDate)
            .startOf("day")
            .isSame(moment().startOf("day"));
        const previousDayOutOfRange = this.isOutsideRange(moment(this.props.availabilityDate).subtract(1, "days").startOf("day"));
        if (!isAvailabilityDateToday && !previousDayOutOfRange) {
            return (_jsxs("div", Object.assign({ className: "mx-2 px-2", role: "button" }, A11yHelpers.onClickOrEnterOrSpace(() => this.onPreviousDateClick()), { children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Back" })] })));
        }
        return (_jsxs("div", { className: "mx-2 px-2 text-muted", children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Back" })] }));
    }
    renderNextDayButton() {
        const nextDayOutOfRange = this.isOutsideRange(moment(this.props.availabilityDate).add(1, "days").startOf("day"));
        if (!nextDayOutOfRange) {
            return (_jsxs("div", Object.assign({ className: "mx-2 px-2", role: "button" }, A11yHelpers.onClickOrEnterOrSpace(() => this.onNextDateClick()), { children: [_jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Forward" })] })));
        }
        return (_jsxs("div", { className: "mx-2 px-2 text-muted", children: [_jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Forward" })] }));
    }
    onPreviousDateClick() {
        const newAvailabilityDate = moment(this.props.availabilityDate)
            .subtract(1, "d")
            .toDate();
        this.updateAvailabilityDate(newAvailabilityDate);
    }
    onNextDateClick() {
        const newAvailabilityDate = moment(this.props.availabilityDate)
            .add(1, "d")
            .toDate();
        this.updateAvailabilityDate(newAvailabilityDate);
    }
    // @ts-expect-error - TS7006 - Parameter 'availabilityDate' implicitly has an 'any' type.
    updateAvailabilityDate(availabilityDate) {
        this.setState({ availabilityDate });
        this.props.onAvailabilityDateChange(availabilityDate);
    }
    renderNextButton() {
        if (this.props.selectedTimeSlot) {
            return (_jsxs(Link, { to: {
                    pathname: meetingConfirmPath({}),
                    search: this.props.pageParams,
                }, className: "btn btn-primary btn-lg", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
        }
        return (
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
        _jsxs("button", { disabled: "true", className: "btn btn-primary btn-lg", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
    }
    renderCourseSchedule() {
        if (!this.props.courseSchedule || !this.props.courseSchedule.length) {
            return null;
        }
        return (_jsxs("div", { className: "col-md-4 mb-3", children: [_jsx("div", { children: _jsx("h4", { children: "My Schedule" }) }), _jsx("div", { className: "card", children: _jsx("div", { className: "card-body", children: this.props.courseSchedule.map(this.renderCourseSectionSchedule) }) })] }));
    }
    // @ts-expect-error - TS7006 - Parameter 'day' implicitly has an 'any' type.
    isOutsideRange(day) {
        return !(
        /**
         * Inclusion logic (inverted to determine if day is outside of range):
         * Date is today or later
         * If a range start is specified, date is after the start
         * If a range end is specified, date is before the end
         */
        (day.isSameOrAfter(moment().startOf("day")) &&
            (!this.props.startRange ||
                day.isSameOrAfter(moment(this.props.startRange).startOf("day"))) &&
            (!this.props.endRange ||
                day.isSameOrBefore(moment(this.props.endRange).endOf("day")))));
    }
    renderLongDatePicker() {
        return (_jsx(SingleDatePicker
        // @ts-expect-error - TS2339 - Property 'availabilityDate' does not exist on type 'Readonly<{}>'.
        , { 
            // @ts-expect-error - TS2339 - Property 'availabilityDate' does not exist on type 'Readonly<{}>'.
            date: moment(this.state.availabilityDate), 
            // @ts-expect-error - TS7006 - Parameter 'date' implicitly has an 'any' type.
            onDateChange: (date) => this.updateAvailabilityDate(date.toDate()), 
            // @ts-expect-error - TS2339 - Property 'longFocused' does not exist on type 'Readonly<{}>'.
            focused: this.state.longFocused, onFocusChange: ({ focused }) => this.setState({ longFocused: focused }), id: "availabilityDateLong", displayFormat: "dddd MMMM Do", isOutsideRange: this.isOutsideRange, block: true }));
    }
    renderShortDatePicker() {
        return (_jsx(SingleDatePicker
        // @ts-expect-error - TS2339 - Property 'availabilityDate' does not exist on type 'Readonly<{}>'.
        , { 
            // @ts-expect-error - TS2339 - Property 'availabilityDate' does not exist on type 'Readonly<{}>'.
            date: moment(this.state.availabilityDate), 
            // @ts-expect-error - TS7006 - Parameter 'date' implicitly has an 'any' type.
            onDateChange: (date) => this.updateAvailabilityDate(date.toDate()), 
            // @ts-expect-error - TS2339 - Property 'shortFocused' does not exist on type 'Readonly<{}>'.
            focused: this.state.shortFocused, onFocusChange: ({ focused }) => this.setState({ shortFocused: focused }), id: "availabilityDateShort", displayFormat: "ddd MMM D", numberOfMonths: 1, block: true, withPortal: true, isOutsideRange: this.isOutsideRange }));
    }
    render() {
        // console.log("blah = ", this.props.timeSlots);
        return (_jsxs("div", { children: [this.props.isThirdPartyScheduler ? (_jsxs("div", { className: "alert alert-warning mt-3", role: "alert", children: [_jsx("span", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }), " The times listed below are in ", _jsx("em", { children: "your" }), " time zone. (", moment.tz.guess(), ")"] })) : (_jsx("div", { className: "mt-1", children: _jsxs("small", { className: "text-muted", children: [_jsx("span", { className: "fa fa-globe", "aria-hidden": "true" }), " Time Zone:", " ", moment.tz.guess()] }) })), _jsxs("div", { className: "row mt-2", children: [_jsxs("div", { className: `${this.props.courseSchedule && this.props.courseSchedule.length
                                ? "col-md-8"
                                : "col-12"} text-center mb-3`, children: [_jsxs("div", { className: "d-flex p-3 justify-content-center align-items-center", children: [this.renderBackButton(), _jsx("div", { className: "mx-3 d-none d-sm-block", children: this.renderLongDatePicker() }), _jsx("div", { className: "mx-3 d-block d-sm-none", children: this.renderShortDatePicker() }), this.renderNextDayButton()] }), this.props.isLoadingTimeSlots && (_jsxs("div", { className: "mt-3", children: [_jsx("div", { className: "mb-2", children: "Please wait while we load available times..." }), _jsx(LoadingIndicator, { isLoading: this.props.isLoadingTimeSlots })] })), this.props.hasLoadingTimeSlotsError && (_jsxs("div", { className: "alert alert-danger", children: [_jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), " ", this.props.loadingTimeSlotsErrorMessage] })), !this.props.isLoadingTimeSlots &&
                                    !this.props.hasLoadingTimeSlotsError &&
                                    this.props.timeSlots.map(this.renderTimeSlot), !this.props.isLoadingTimeSlots &&
                                    !this.props.hasLoadingTimeSlotsError &&
                                    (!this.props.timeSlots || !this.props.timeSlots.length) && (_jsxs("div", { className: "alert alert-warning mt-3", children: [_jsx("span", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }), " ", "Sorry! There are no available times for this day. Try changing the date."] }))] }), this.renderCourseSchedule()] }), _jsxs("div", { className: "mb-3 pb-2 d-flex justify-content-between", children: [_jsxs(Link, { to: {
                                pathname: meetingTypePath({}),
                                search: this.props.pageParams,
                            }, className: "btn btn-outline-dark btn-lg", children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), " Previous"] }), this.renderNextButton()] })] }));
    }
}
export default MeetingScheduler;
